
import Popover from 'vux/src/components/popover/index.vue'

import PopTips from '../PopTips/PopTips';
import utils from '@/utils/utils';

export default {
name: 'calendar',
components: {
Popover,
PopTips,
},
props: {
isShow: Boolean,

multi: {
type: Boolean,
default: false
},

range:{
type: Boolean,
default: false
},

value: {
type: Array,
default: function(){
return []
}
},

begin:  {
type: Array,
default: function(){
return []
}
},

end:  {
type: Array,
default: function(){
return []
}
},

weeks: {
type: Array,
default: function(){
const lanType = localStorage.getItem('lan_type');

return this.$store.state.multiLanguage.weekDay[lanType - 1];
}
},
},
data() {
return {
calendarData: [],
currentYear: '',
currentMonth: '',
currentDay: '',
rangeBegin: {},
rangeEnd: {},
curLanType: 1,
};
},
watch: {
rangeEnd: {
handler(newRangeEnd){

},
deep: true,
},
},
mounted() {
this.curLanType = window.localStorage.getItem('lan_type');
this.init();

setTimeout(() => {
this.initBeginAndEnd();
}, 200);
},
methods: {
init(){
let now = new Date();
let curYear = now.getFullYear();
let curMonth = now.getMonth();
let curDay = now.getDate();

this.currentYear = curYear;
this.currentMonth = curMonth;
this.currentDay = curDay;


this.render(curYear, curMonth, curDay);
for(let k = 1; k < 12; k++){
curMonth = curMonth + 1 < 12 ? curMonth + 1 : 0;

if(curMonth == 0){
curYear += 1;
}

this.render(curYear, curMonth);
}
},

/** 显示当前设置的起始日期 */
initBeginAndEnd(){
const begin = this.begin,
end = this.end,
beginIdxArr = this.traverseDate(begin),
endIdxArr = this.traverseDate(end),
beginDataset = {
year: begin[0],
month: +begin[1] - 1,
day: begin[2],
monthIndex: beginIdxArr[0],
lineIndex: beginIdxArr[1],
dayIndex: beginIdxArr[2],
},
endDataset = {
year: end[0],
month: +end[1] - 1,
day: end[2],
monthIndex: endIdxArr[0],
lineIndex: endIdxArr[1],
dayIndex: endIdxArr[2],
};

this.setRangeHash(beginDataset, 'begin');
this.setSelectedDay(beginIdxArr[0], beginIdxArr[1], beginIdxArr[2], true);

this.setRangeHash(endDataset, 'end');
this.setSelectedDay(endIdxArr[0], endIdxArr[1], endIdxArr[2]);
this.renderRange();
},

/** 遍历日历 */
traverseDate(origin){
let monthIdx = 0,
rowIdx = 0,
dayIdx = 0;

const monthArr = this.calendarData;
first:
for(let i = 0; i < monthArr.length; i++){
if(monthArr[i].year == origin[0] && utils.zeroPad(monthArr[i].month + 1) == origin[1]){
const rowArr = monthArr[i];

second:
for(let j = 0; j < rowArr.day.length; j++){
const dayArr = rowArr.day[j];

third:
for(let k = 0; k < dayArr.length; k++){
if(utils.zeroPad(dayArr[k].day) == origin[2]){
monthIdx = i;
rowIdx = j;
dayIdx = k;

break first;
}
}
}
}
}

return [monthIdx, rowIdx, dayIdx];
},

/** 渲染日期 */
render(y, m, today) {
let firstDayOfMonth = new Date(y, m, 1).getDay();         
let lastDateOfMonth = new Date(y, m + 1, 0).getDate();    
let i, line = 0, temp = [];

temp[line] = [];
for (i = 1; i <= lastDateOfMonth; i++) {
let day = new Date(y, m, i).getDay();   

if(i == 1 && day != 0) {

for (let j = 0; j < firstDayOfMonth; j++) {
temp[line].push({day: '', disabled: true});
}
}


if (this.range) {
let options = {day: i, isToday: i == today};

if(y == this.currentYear && m == this.currentMonth && i < this.currentDay){
options['disabled'] = true;
}

temp[line].push(options);
}else if(this.multi){ // 多选

}else{    // 单选

}


if (day == 6 && i < lastDateOfMonth) {
line++;
temp[line] = [];
}
}
this.calendarData.push({year: y, month: m, day: temp});
},

/** 选择日期 */
select(event) {
const {dataset} = event.currentTarget;

if(!dataset.monthIndex){
return ;
}

if (this.range) {   // 日期范围选择
if(Object.keys(this.rangeBegin).length == 0) {


}else{
let beginHash = this.rangeBegin;
let endHash = this.rangeEnd;


if(Object.keys(endHash).length == 0){
const bool = this.compareDate(new Date(beginHash.year, beginHash.month, beginHash.day).getTime(), new Date(dataset.year, dataset.month, dataset.day).getTime());

if(bool){
this.setRangeHash(dataset, 'end');
this.setSelectedDay(dataset.monthIndex, dataset.lineIndex, dataset.dayIndex);
this.renderRange();


}else{
this.setSelectedDay(beginHash.monthIndex, beginHash.lineIndex, beginHash.dayIndex, true, true);
this.setSelectedDay(dataset.monthIndex, dataset.lineIndex, dataset.dayIndex, true);
this.setRangeHash(dataset, 'begin');
}
}else{

this.resetRange();
this.setSelectedDay(beginHash.monthIndex, beginHash.lineIndex, beginHash.dayIndex, true, true);
this.setSelectedDay(endHash.monthIndex, endHash.lineIndex, endHash.dayIndex, false, true);
this.setSelectedDay(dataset.monthIndex, dataset.lineIndex, dataset.dayIndex, true);


this.rangeEnd = {};

this.setRangeHash(dataset, 'begin');
}

this.emitSelectDateEvent();
}
}else if(this.multi) {  // 日期多选（有需求再补充）

}else{                  // 单日期选择（有需求再补充）

}

event.stopPropagation();
},

/** 广播选择日期事件 */
emitSelectDateEvent(){
const rangeBegin = this.rangeBegin;
const rangeEnd = this.rangeEnd;

const resp = {
start: [rangeBegin.year, utils.zeroPad(Number(rangeBegin.month) + 1), utils.zeroPad(rangeBegin.day)],
end: [rangeEnd.year, utils.zeroPad(Number(rangeEnd.month) + 1), utils.zeroPad(rangeEnd.day)],
};

this.$emit('on-select', resp);
},

/** 保存选中的日期 */
setRangeHash(dataset, hashType){
let hash = hashType == 'begin' ? this.rangeBegin : this.rangeEnd;

hash['year'] = dataset.year;
hash['month'] = dataset.month;
hash['day'] = dataset.day;
hash['monthIndex'] = dataset.monthIndex;
hash['lineIndex'] = dataset.lineIndex;
hash['dayIndex'] = dataset.dayIndex;
},

/** 设置选中的日期 */
setSelectedDay(monthIdx, lineIndex, dayIndex, isBegin = false, reset = false){
let curTarget = this.calendarData[monthIdx]['day'][lineIndex][dayIndex];
let temp = {};

if(!reset){
temp = Object.assign({}, curTarget, {selected: true, extra: isBegin ? this.$i18n.t('hotel.TOURISM_CHECK_IN_HOTEL') : this.$i18n.t('hotel.TOURISM_LEAVE_HOTEL')});
}else{
temp = Object.assign({}, curTarget, {selected: false, extra: ''});
}
this.$set(this.calendarData[monthIdx]['day'][lineIndex], dayIndex, temp);
},

/** 比较两个日期的大小 */
compareDate(start, end){
return start < end;
},

/** 设置日期范围 */
renderRange(reset = false){
let beginHash = this.rangeBegin,
endHash = this.rangeEnd;

let beginMonthIdx = parseInt(beginHash.monthIndex);
let endMonthIdx = parseInt(endHash.monthIndex);

for(let month = beginMonthIdx; month <= endMonthIdx; month++){
this.calendarData[month]['day'].forEach((line, idx1) => {
line.forEach((date, idx2) => {
let targetDay = null;


if(beginMonthIdx == endMonthIdx){
if(date.day >= beginHash.day && date.day <= endHash.day){
targetDay = this.calendarData[month]['day'][idx1][idx2];

if(date.day == beginHash.day){
targetDay['isBegin'] = true;
}else if(date.day == endHash.day){
targetDay['isEnd'] = true;
}
}
}else{  // 不同月份
if(month == beginMonthIdx){
if(date.day >= beginHash.day){
targetDay = this.calendarData[month]['day'][idx1][idx2];

if(date.day == beginHash.day){
targetDay['isBegin'] = true;
}
}
}else if(month == endMonthIdx){
if(date.day <= endHash.day){
targetDay = this.calendarData[month]['day'][idx1][idx2];

if(date.day == endHash.day){
targetDay['isEnd'] = true;
}
}
}else{
targetDay = this.calendarData[month]['day'][idx1][idx2];
}
}

if(targetDay){
if(reset){
targetDay['isRange'] = false;
targetDay['isBegin'] = false;
targetDay['isEnd'] = false;
}else{
targetDay['isRange'] = true;
}

this.$set(this.calendarData[month]['day'][idx1], idx2, targetDay);
}
});
});
}
},

/** 重置日期范围 */
resetRange(){
this.renderRange(true);
},

/** 小于10的数字补零 */
zeroPad(n){

return utils.zeroPad(n);
},
}
}




// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.vue